'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { trackEvent } from '@/lib/analytics';
import { heroPrimaryCtaLabel } from '@/lib/invite-only';
import { Button } from '@/components/ui/button';
import { HeroParallax } from '@/components/ui/hero-parallax';
import { BackgroundBeams } from '@/components/ui/background-beams';
import { motion } from 'motion/react';
export function Hero(t0) {
  const $ = _c(26);
  const {
    onWatchDemo
  } = t0;
  let t1;
  if ($[0] !== onWatchDemo) {
    t1 = function handleWatchDemo() {
      trackEvent("demo_click", {
        location: "hero"
      });
      onWatchDemo();
    };
    $[0] = onWatchDemo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleWatchDemo = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroParallax />;
    t3 = <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[var(--landing-bg)]" aria-hidden={true} />;
    t4 = <BackgroundBeams />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 id="hero-heading" className="hero-headline font-heading font-bold text-white drop-shadow-lg animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both">Sync Prop Screens. Instantly. Seamlessly.</h1>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <motion.p initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6,
      duration: 0.5,
      ease: "easeOut"
    }} className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-100 md:text-xl lg:text-2xl">Pre-build sequences. One-tap broadcast to any device. No logins for viewers. Built for chaotic film sets.</motion.p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      y: 16
    };
    t8 = {
      opacity: 1,
      y: 0
    };
    t9 = {
      delay: 0.9,
      duration: 0.4
    };
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link href="/signup" onClick={_temp} className="inline-flex h-12 w-full items-center justify-center rounded-xl bg-[var(--landing-accent-red)] px-8 font-semibold text-white shadow-[0_0_24px_-2px_rgba(255,77,77,0.4)] transition-all duration-300 hover:opacity-95 hover:shadow-[0_0_32px_-2px_rgba(255,77,77,0.5)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--landing-accent-red)] focus-visible:ring-offset-2 focus-visible:ring-offset-black sm:w-auto">{heroPrimaryCtaLabel()}</Link>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== handleWatchDemo) {
    t11 = <motion.div initial={t7} animate={t8} transition={t9} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">{t10}<Button type="button" variant="outline" size="lg" onClick={handleWatchDemo} className="h-12 w-full border-2 border-[var(--landing-accent-blue)] bg-transparent font-semibold text-[var(--landing-accent-blue)] transition-all duration-300 hover:bg-[var(--landing-accent-blue)]/10 hover:shadow-[0_0_24px_-4px_rgba(0,191,255,0.3)] focus-visible:ring-[var(--landing-accent-blue)] focus-visible:ring-offset-black sm:w-auto" aria-label="Watch 60 second product demo">Watch 60s Demo</Button></motion.div>;
    $[11] = handleWatchDemo;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      scale: 0.95
    };
    t13 = {
      opacity: 1,
      scale: 1
    };
    t14 = {
      delay: 1.1,
      duration: 0.5
    };
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
  } else {
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <motion.div initial={t12} animate={t13} transition={t14} className="mt-12 flex items-end justify-center gap-4 md:gap-6" aria-hidden={true}><SyncDevice className="h-14 w-9 md:h-16 md:w-10" delay={0} /><SyncDevice className="h-12 w-16 md:h-14 md:w-20" delay={0.2} /><SyncDevice className="h-14 w-9 md:h-16 md:w-10" delay={0.4} /></motion.div>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  let t17;
  let t18;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0
    };
    t17 = {
      opacity: 1
    };
    t18 = {
      delay: 1.5
    };
    $[17] = t16;
    $[18] = t17;
    $[19] = t18;
  } else {
    t16 = $[17];
    t17 = $[18];
    t18 = $[19];
  }
  let t19;
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      y: [0, 6, 0]
    };
    t20 = {
      duration: 2,
      repeat: Number.POSITIVE_INFINITY,
      ease: "easeInOut"
    };
    $[20] = t19;
    $[21] = t20;
  } else {
    t19 = $[20];
    t20 = $[21];
  }
  let t21;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-xs uppercase tracking-widest">Scroll</span>;
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <motion.div initial={t16} animate={t17} transition={t18} className="absolute bottom-8 left-1/2 -translate-x-1/2 md:bottom-10" aria-hidden={true}><motion.div animate={t19} transition={t20} className="flex flex-col items-center gap-1 text-zinc-300">{t21}<svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg></motion.div></motion.div>;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[24] !== t11) {
    t23 = <section id="top" className="relative flex min-h-dvh min-h-[100dvh] flex-col items-center justify-center overflow-hidden px-4 pt-24 pb-32 md:pt-28 md:pb-36" aria-labelledby="hero-heading">{t2}{t3}{t4}<div className="relative z-10 mx-auto max-w-4xl text-center">{t5}{t6}{t11}{t15}{t22}</div></section>;
    $[24] = t11;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  return t23;
}
function _temp() {
  return trackEvent("signup_click", {
    location: "hero"
  });
}
function SyncDevice(t0) {
  const $ = _c(7);
  const {
    className,
    delay
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      boxShadow: ["0 0 0 0 rgba(0, 212, 255, 0)", "0 0 0 4px rgba(0, 212, 255, 0.3)", "0 0 0 0 rgba(0, 212, 255, 0)"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== delay) {
    t2 = {
      duration: 1.5,
      repeat: Number.POSITIVE_INFINITY,
      delay,
      ease: "easeOut"
    };
    $[1] = delay;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex items-center justify-center rounded-lg border-2 border-white/20 bg-white/10 ${className ?? ""}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="h-2/3 w-2/3 rounded bg-white/20" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3) {
    t5 = <motion.span animate={t1} transition={t2} className={t3}>{t4}</motion.span>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}